import { ClbButton } from '@celebration/react/ClbButton/ClbButton';
import { ILoadActionBulkButtons } from './ILoadActionBulkButtons';

export default function LoadActionBulkButtons(
    props: Readonly<ILoadActionBulkButtons>,
) {
    const { visible, buttons } = props;
    return visible ? (
        <div
            className="loads-filters__right-side"
            data-testid="load-action-bulk-buttons"
        >
            {buttons.map(button => (
                <ClbButton
                    key={button.id}
                    data-testid={button.id}
                    {...button}
                />
            ))}
        </div>
    ) : (
        <div data-testid="load-action-bulk-buttons-empty" />
    );
}
